import SimpleScroller from '@components/SimpleScroller';
import React from 'react';
import { StyledSection } from './styled';

interface ISectionProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  scrollerId?: string;
}

const Section:React.FC<ISectionProps> = ({scrollerId, children, ...props}) => {
  return (
    <StyledSection {...props}>
      {children}
      {
        !!scrollerId && <SimpleScroller id={scrollerId} />
      }
    </StyledSection>
  );
}

export default Section;
